<template>
	<div class="main">
		<div class="row">
			<div class="col-md-4">
				<router-link v-bind:to="'/services/' + idService + '/requests'" class="btn btn-info">{{ $t('Back') }}</router-link>
			</div>
			<div class="col-md-4 text-center">
				<h3>{{ $t('Logs') }}</h3>
			</div>
		</div>
		<hr />
		<table class="table table-striped">
			<thead>
				<tr>
					<th class="col-md-2">{{ $t('Date') }}</th>
					<th class="col-md-8">{{ $t('Message') }}</th>
					<th class="col-md-2"></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="log of logs" v-bind:key="log.idRequestLog">
					<td>{{ formatDate(log.date) }}</td>
					<td style="overflow-wrap: break-word; word-break: break-all">{{ log.message }}</td>
					<td class="text-right">
						<router-link v-bind:to="'/services/' + log.idService + '/requests/' + log.idRequest + '/logs/' + log.idRequestLog" class="btn btn-default"><span class="fa fa-search"></span></router-link>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import moment from "moment";

export default {
	props: {
		requestsService: {
			type: Object,
		},
	},
	data() {
		return {
			logs: [],
		};
	},
	methods: {
		formatDate(value) {
			return moment(value).format("DD/MM/YYYY HH:mm:ss");
		},
		formatJSON(value) {
			return JSON.stringify(JSON.parse(value), undefined, "   ");
		},
	},
	async created() {
		this.idService = this.$route.params.idService;
		this.idRequest = this.$route.params.idRequest;
		this.logs = await this.requestsService.getLogs(this.idService, this.idRequest);
	},
};
</script>

<style>
.main {
	padding: 30px;
}
.text-right {
	text-align: right;
}
pre {
	background-color: transparent !important;
	border: 0 !important;
	white-space: pre-wrap;
	word-wrap: break-word;
}
.request {
	height: 100px !important;
}
</style>
